import React, { forwardRef, useCallback } from 'react';

export default forwardRef(function SupportButton({ children, onClick, component, ...rest }, ref) {
  const handleClick = useCallback((evt) => {
    if (onClick) { onClick(evt); }

    const RedmineHelpdeskWidget = window.RedmineHelpdeskWidget;

    if (RedmineHelpdeskWidget) {
      if (!RedmineHelpdeskWidget.loaded) {
        RedmineHelpdeskWidget.load_schema()
      }

      RedmineHelpdeskWidget.show();

      evt.preventDefault();
    }

    const carrotquest = window.carrotquest

    if (carrotquest) {
      if (carrotquest.messenger?.state === 'opened') {
        carrotquest.messenger.reset()
      } else {
        carrotquest.open()
      }

      evt.preventDefault();
    }
  }, [onClick]);

  const Component = component ?? 'button';

  return (
    <Component type="button" {...rest} onClick={handleClick} ref={ref}>
      {children}
    </Component>
  )
});
